import type { Point } from "web_myplann/Chat/Types/pinchZoom";

export const distanceBetween = (a: Point, b: Point) =>
	Math.hypot(a.x - b.x, a.y - b.y);
